module.exports = __webpack_public_path__ + "img/value-absolute.0b7b1c37.svg";